export default __webpack_public_path__ + "b40afad8f65f198c81a044c9fb47d004.svg";